const customTextInputStyles = {
  textField: {
    "& .MuiOutlinedInput-input": {
      padding: "0.4375rem",
    },
    "& .MuiOutlinedInput-root": {
      border: "none !important",
      padding: "0.4375rem !important",
      height: "2.5rem",
      borderRadius: "0.5rem",
    },
    "& .MuiInputBase-input": {
      padding: "0.4375rem !important",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none !important",
    },
  },
} as const;

export default customTextInputStyles;
